/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { Section } from 'ui/molecules/Section/Section';
import { Presentation } from 'ui/organisms/Presentation/Presentation';

import styles from './CompanyDataCallToAction.module.scss';

export const CompanyDataCallToAction = () => {
  const { t } = useInt();

  return (
    <Section
      layout="split"
      title={t('Build Trust Into Your Platform from Day One')}
      description={t('Empower your buyers. Protect your brand. Onboard only verified, trustworthy sellers.')}
      className={styles.section}
    >
      <Presentation hasWhiteBg />
    </Section>
  );
};
